import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './demo.css';
import logo from './inpkt.png';

const API_BASE = 'https://be.inpockethr.com/api';

function generateAllSlots() {
    const slots = [];
    for (let hour = 9; hour <= 21; hour++) {
        for (let min = 0; min < 60; min += 30) {
            if (hour === 21 && min === 30) continue;
            const ampm = hour >= 12 ? 'PM' : 'AM';
            const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
            const displayMin = min === 0 ? '00' : '30';
            slots.push(`${displayHour}:${displayMin} ${ampm}`);
        }
    }
    return slots;
}
const ALL_SLOTS = generateAllSlots();

export default function DemoBooking() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        company: "",
        phone: "",
        date: "",
        slot: "",
        message: ""
    });
    const [availableSlots, setAvailableSlots] = useState([]);
    const [loadingSlots, setLoadingSlots] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');

    // Fetch available slots whenever date changes
    useEffect(() => {
        if (form.date) {
            setLoadingSlots(true);
            setAvailableSlots([]);
            setForm(prev => ({ ...prev, slot: '' }));
            axios.get(`${API_BASE}/slots/${form.date}`)
                .then(res => setAvailableSlots(res.data))
                .catch(() => setAvailableSlots([]))
                .finally(() => setLoadingSlots(false));
        }
    }, [form.date]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.date || !form.slot) {
            alert('Please select a date and a time slot.');
            return;
        }

        setSubmitting(true);
        try {
            const res = await axios.post(`${API_BASE}/book-demo`, form);
            setSuccessMsg(res.data.message);
            setForm({ name: '', email: '', company: '', phone: '', date: '', slot: '', message: '' });
            setAvailableSlots([]);
        } catch (error) {
            const msg = error.response?.data?.error || 'Failed to book demo. Ensure backend is running on port 5000.';
            alert(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="booking-container">
            <div className="booking-card">
                <div className="brand-header">
                    <img src={logo} alt="Inpocket HR Logo" className="brand-logo" />
                </div>

                <div className="quote-container">
                    <p className="animated-quote">
                        "Success starts with teamwork, trust, and talent. <br />
                        Welcome to the <span className="highlight-text">Inpocket HR</span> family."
                    </p>
                </div>

                <p className="subtitle">Empower your workforce with smarter HR operations. Book your preferred slot.</p>

                <form onSubmit={handleSubmit} className="booking-form">

                    {successMsg && (
                        <div className="success-banner">
                            ✅ {successMsg}
                        </div>
                    )}
                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Name"
                            className="input-field"
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="email"
                            placeholder="Email"
                            className="input-field"
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="text"
                            placeholder="Company Name"
                            className="input-field"
                            value={form.company}
                            onChange={(e) => setForm({ ...form, company: e.target.value })}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="tel"
                            placeholder="Contact Number"
                            className="input-field"
                            value={form.phone}
                            onChange={(e) => setForm({ ...form, phone: e.target.value })}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="date">Select Date</label>
                        <input
                            type="date"
                            id="date"
                            className="input-field"
                            value={form.date}
                            min={new Date().toISOString().split('T')[0]}
                            onChange={(e) => setForm({ ...form, date: e.target.value })}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Available Slots (9 AM – 9 PM){form.date ? '' : ' — select a date first'}</label>
                        {loadingSlots && <p className="slots-hint">Loading slots...</p>}
                        {!loadingSlots && form.date && availableSlots.length === 0 && (
                            <p className="slots-hint">No slots available for this date.</p>
                        )}
                        <div className="slots-grid">
                            {form.date && ALL_SLOTS.map((s, index) => {
                                const isAvailable = availableSlots.includes(s);
                                return (
                                    <button
                                        type="button"
                                        key={index}
                                        className={`slot-btn ${form.slot === s ? 'selected' : ''}`}
                                        onClick={() => isAvailable && setForm({ ...form, slot: s })}
                                        disabled={!isAvailable}
                                        title={!isAvailable ? 'Slot unavailable' : ''}
                                    >
                                        {s}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <button type="submit" className="submit-btn" disabled={submitting}>
                        {submitting ? 'Booking...' : 'Book Demo'}
                    </button>
                </form>
            </div>
        </div>
    );
}
